import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryPage } from "./components/Error.tsx";

Sentry.init({
  dsn: import.meta.env.PROD ? "https://6269fd30102226eabcaec8abcea33364@o4509073019895808.ingest.us.sentry.io/4509073022320640" : undefined
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<ErrorBoundaryPage />}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
